<div class="settings-profile-page">

    <div class="settings-profile-page-anchor" inViewport
        (inViewportAction)="onToolbarMinimizerAnchorViewportChange($event)">
    </div>

    <div class="settings-profile-page-toolbar" [class.settings-profile-page-toolbar--minimized]="isMinimizedToolbar">

        <rpc-button class="settings-profile-page-toolbar-back" [iconSquareButton]="true" [iconName]="'left'"
            [title]="'PROFILE_SETTINGS_PAGE.TITLES.BACK'" (clicked)="onNavigateBack()">
        </rpc-button>

        <div class="settings-profile-page-toolbar-title rpc-title-font"
            [title]="'PROFILE_SETTINGS_PAGE.TITLES.SETTINGS' | translate">
            {{ 'PROFILE_SETTINGS_PAGE.TITLES.SETTINGS' | translate }}
        </div>

    </div>

    <profile-settings [settings]="settings$ | async" [newMatchSettings]="newMatchSettings$ | async"
        [isSelfProfile]="isSelfProfile$ | async" [isSmsAvailable]="hasPhones$ | async"
        [hasSmsAlertsNumber]="hasSmsAlertsNumber$ | async" class="settings-profile-page-body">
    </profile-settings>

    <rpc-scroll-to-top class="rpc-scroll-to-top-wrap">
    </rpc-scroll-to-top>

</div>